import { AlarmCodeFilter, AlertsFilter, DoorFilter, GatewayFilter, GeofenceFilter, PowerFilter } from './filters'
import { type Filters } from './MapContext'

interface MapFilterProps {
  activeFilter?: keyof Filters
  setActiveFilter: (key: keyof Filters | undefined) => void
  tableControls?: React.ReactNode
}

export const MapFilters = ({ tableControls, activeFilter, setActiveFilter }: MapFilterProps) => {
  const closeFilters = () => setActiveFilter(undefined)

  return (
    <>
      <FilterBar
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
        onClose={closeFilters}
        tableControls={tableControls}
      />
    </>
  )
}

const FilterBar = ({
  activeFilter,
  setActiveFilter,
  onClose,
  tableControls,
}: MapFilterProps & { onClose: () => void }) => (
  <div className="hidden md:flex flex-wrap items-center gap-2 min-w-0">
    <FilterList
      tableControls={tableControls}
      activeFilter={activeFilter}
      setActiveFilter={setActiveFilter}
      onClose={onClose}
    />
  </div>
)

const FilterList = ({
  tableControls,
  activeFilter,
  setActiveFilter,
  onClose,
}: MapFilterProps & { onClose: () => void }) => (
  <div className="flex flex-wrap items-center gap-2">
    <div className="flex flex-wrap gap-2">
      <GeofenceFilter onSelect={onClose} />
      <PowerFilter onSelect={onClose} />
      <GatewayFilter onSelect={onClose} />
    </div>
    <div className="flex flex-wrap gap-2">
      <DoorFilter onSelect={onClose} />
      <AlarmCodeFilter
        isOpen={activeFilter === 'alarmCodes'}
        onToggle={() => setActiveFilter(activeFilter === 'alarmCodes' ? undefined : 'alarmCodes')}
      />
      <AlertsFilter
        isOpen={activeFilter === 'alerts'}
        onToggle={() => setActiveFilter(activeFilter === 'alerts' ? undefined : 'alerts')}
      />
    </div>
    {tableControls}
  </div>
)
